/*封装请求方法 axios*/
import axios from '@/plugins/axios'
import store from '@/store';
import router from '@/router';
import {ElMessageBox } from 'element-plus';
// this.axios.defaults.timeout = 20000
// // this.axios.defaults.withCredentials=true
// axios.defaults.crossDomain=true
let wraning_msg = null;
export default {
    fetchGet (url, params = {}) {
      return axios.get(url, { params }).then(res => {
        if (res && res.code && res.message && res.code >= 500) {
          if (!wraning_msg) {
            if (res.code == 501) {
              wraning_msg = ElMessageBox.alert('请重新登录！', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  store.signOut();
                  wraning_msg = null;
                  router.push('/login');
                },
              })
            }
            if (res.code == 500 || res.code == 502) {
              wraning_msg = ElMessageBox.alert(res.code == 500 ? res.message : '未开通权限，请与管理员联系！', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  wraning_msg = null;
                },
              })
            }
          }
        }
        return res
      })
    },
    fetchPost (url, params = {}, res_params = null) {
      return axios.post(url, params, res_params).then(res => {
        if (res && res.code && res.message && res.code >= 500) {
          if (!wraning_msg) {
            if (res.code == 501) {
              wraning_msg = ElMessageBox.alert('请重新登录！', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  store.signOut();
                  wraning_msg = null;
                  router.push('/login');
                },
              })
            }
            if (res.code == 500 || res.code == 502) {
              wraning_msg = ElMessageBox.alert(res.code == 500 ? res.message : '未开通权限，请与管理员联系！', '提示', {
                confirmButtonText: '确定',
                callback: () => {
                  store.signOut();
                  wraning_msg = null;
                  router.push('/login');
                },
              })
            }
          }
        }
        return res
      })
    },
    toPage (url) {
      router.push(url);
    }
  }
